module.exports = __webpack_public_path__ + "static/media/undraw-season-change-f-99-v.08df94d3.png";